module.exports = __webpack_public_path__ + "img/P619205803.b54a49f9.jpg";